import Button from 'components/Button';
import { useState } from 'react';

const RedirectButton = ({ intl, color, hash }) => {
    // NOTE: Removed isSubmitDisabled, added href
    const [textColor, setTextColor] = useState('#fff');
    const [bgColor, setBgColor] = useState(color);

    return (
        <Button
            text={intl.formatMessage({
                id: 'features.Viewlogy.GuestSection.Form.revisitStreamPage',
                defaultMessage: 'Back to Live Stream',
            })}
            className="guest-submit-button"
            onClick={() => (window.location.hash = hash)} // NOTE: Navigate to another part of the site
            onMouseEnter={() => {
                setBgColor('#fff'); // NOTE: No check for disabled, since always enabled
                setTextColor(color);
            }}
            onMouseLeave={() => {
                setBgColor(color);
                setTextColor('#fff');
            }}
            style={{
                color: textColor,
                border: `2px solid ${color}`,
                backgroundColor: bgColor,
                borderRadius: '6px',
                opacity: 1, // NOTE: Always enabled, so no disabled opacity
                cursor: 'pointer',
                transition: 'all 0.2s ease',
                display: 'flex',
                justifyContent: 'center',
            }}
        />
    );
};

export default RedirectButton;
